import { Skeleton } from 'primereact/skeleton';
import { Column, FlexSpaceBetweenContainer, Row } from '../container/Container';
import Spacing from '../container/Spacing';

const BarChartSkeleton = () => {
	return (
		<Column>
			<Skeleton width="202px" height="24px" className="skeleton" />
			<Spacing height="h-2" />
			<Skeleton width="202px" height="54px" className="skeleton" />
			<Spacing height="h-7" />
			<Row>
				<Skeleton width="16px" height="278px" className="skeleton" />
				<Spacing width="w-[10px]" />
				<Column gap="gap-7">
					<Skeleton width="30px" height="16px" className="skeleton" />
					<Skeleton width="30px" height="16px" className="skeleton" />
					<Skeleton width="30px" height="16px" className="skeleton" />
					<Skeleton width="30px" height="16px" className="skeleton" />
					<Skeleton width="30px" height="16px" className="skeleton" />
					<Spacing width="w-[10px]" />
				</Column>
				<Spacing width="w-[11px]" />
				<FlexSpaceBetweenContainer className="self-end ">
					<Column gap="gap-4">
						<Skeleton
							width="36px"
							height="98px"
							className="skeleton"
						/>
						<Skeleton
							width="36px"
							height="16px"
							className="skeleton"
						/>
					</Column>
					<Column gap="gap-4">
						<Skeleton
							width="36px"
							height="98px"
							className="skeleton"
						/>
						<Skeleton
							width="36px"
							height="16px"
							className="skeleton"
						/>
					</Column>
					<Column gap="gap-4">
						<Skeleton
							width="36px"
							height="98px"
							className="skeleton"
						/>
						<Skeleton
							width="36px"
							height="16px"
							className="skeleton"
						/>
					</Column>
					<Column gap="gap-4">
						<Skeleton
							width="36px"
							height="98px"
							className="skeleton"
						/>
						<Skeleton
							width="36px"
							height="16px"
							className="skeleton"
						/>
					</Column>
					<Column gap="gap-4">
						<Skeleton
							width="36px"
							height="98px"
							className="skeleton"
						/>
						<Skeleton
							width="36px"
							height="16px"
							className="skeleton"
						/>
					</Column>
					<Column gap="gap-4">
						<Skeleton
							width="36px"
							height="98px"
							className="skeleton"
						/>
						<Skeleton
							width="36px"
							height="16px"
							className="skeleton"
						/>
					</Column>
					<Column gap="gap-4">
						<Skeleton
							width="36px"
							height="98px"
							className="skeleton"
						/>
						<Skeleton
							width="36px"
							height="16px"
							className="skeleton"
						/>
					</Column>
				</FlexSpaceBetweenContainer>
			</Row>
		</Column>
	);
};

export default BarChartSkeleton;
